import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProductCard from "../ProductCard";
import { Reveal, useReveal } from "./_shared";

export default function FeaturedShirts({ shirts }) {
  const ref = useReveal(0.1);
  return (
    <section
      className="max-w-7xl mx-auto px-6 md:px-12 pb-20 md:pb-28"
      data-testid="featured-shirts-section"
    >
      <Reveal className="flex items-end justify-between mb-12">
        <div>
          <p className="eyebrow">The Shirt Archive</p>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-2">
            Made to layer, made to last
          </h2>
        </div>
        <Link
          to="/shop?category=shirts"
          className="hidden md:inline-flex items-center gap-2 eyebrow text-[#1A1A1A] hover:gap-3 transition-all"
          data-testid="see-all-shirts"
        >
          See all <ArrowRight size={14} />
        </Link>
      </Reveal>
      <div ref={ref} className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 reveal-stagger">
        {shirts.map((p, i) => (
          <ProductCard key={p.id} product={p} index={i} />
        ))}
      </div>
    </section>
  );
}
